module.exports = __webpack_public_path__ + "images/cavallo-d6b5d6e8a2d43e2ddfee747d32369481.jpg";